import React, { useEffect, useState } from 'react';
import './course';
import './index.scss';
import moment from 'moment';
import {
    Button,
    Col,
    Divider,
    Image,
    Row,
    Typography,
    notification,
    Space,
    Modal,
    Form,
    Input, Upload, Spin, Select, Skeleton, InputNumber, Switch,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import vDOts from '../../../src/img/v-dots.png';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    UploadOutlined,
    ExclamationCircleOutlined,
    ArrowLeftOutlined,
} from '@ant-design/icons';

import API_SERVICE from 'shared/services/api-service';
import { getImageUrl, UploadImage } from 'shared/services/Utility';

import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { fillEn } from 'client/src/methods/forms';
import Parameters from 'shared/parameters';
import plusIcon from '../../../src/img/plus.png';
import arrowLeft from '../../../src/img/arrow-left.png';
import addCat from '../../../src/img/add-category.png';
import stars from '../../../src/img/stars.png';
import openBook from '../../../src/img/open-book.png';
import imgIcon from '../../../src/img/image-icon.png';
import uploadIcon from '../../../src/img/upload.png';
import deFlag from '../../../src/img/de-icon.png';
import enFlag from '../../../src/img/en-icon.png';
import video from '../../../src/img/video.png';
import stepCircle from '../../../src/img/step-circle.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
interface Props {
    location: any;
    hideHeader?: boolean;
}
const { confirm } = Modal;
const { Title } = Typography;
const { Option } = Select;
export default function CourseForm(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();
    const RouteParams: any = useParams();
    const [form] = Form.useForm();
    const [saving, setSaving] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [instructors, setInstructors] = useState([] as any[]);
    const [categories, setCategories] = useState([] as any[]);
    const [levels, setLevels] = useState([] as any[]);
    const [item, setItem] = useState(null as any);
    const [plan, setPlan] = useState(null as any);
    const [image, setImage] = useState({ image: null, imageId: null } as any);
    const [uploading, setUploading] = useState(false);
    const [deletingItem, setDeletingItem] = useState(false);
    const [lang, setLang] = useState('' as any);
    const refreshItem = async () => {
        try {
            setFetching(true);
            const {
                data: { data },
            } = await API_SERVICE.fetchCourseByIdAdmin(RouteParams['id']);
            setItem({
                ...data,
                instructor_id: data.user_id,
            });
            setImage({ image: getImageUrl(data.thumbnail), imageId: data.thumbnail_id });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    const refreshMetaData = async () => {
        try {
            if(Parameters.Mode !== 'CLIENT'){
              const {
                data: { data: { items: i } },
              } = await API_SERVICE.fetchUsers({ per_page: 1000 });
              setInstructors(i);
              const {
                data: { data: { items: c } },
              } = await API_SERVICE.fetchCategoriesAdmin({ per_page: 1000 });
              setCategories(c);
              const {
                data: { data: { items: l } },
              } = await API_SERVICE.fetchLevelsAdmin({ per_page: 1000 });
              setLevels(l);
            }else{
              const {
                data: { data: { items: c } },
              } = await API_SERVICE.fetchCategories({ per_page: 1000 });
              setCategories(c);
              const {
                data: { data: { items: l } },
              } = await API_SERVICE.fetchLevels({ per_page: 1000 });
              setLevels(l);
            }

        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }
    };
    const uploadImage = async (file: any) => {
        setUploading(true);
        setImage({ image: null, imageId: null });
        const { image, imageId, error } = await UploadImage(file);
        if (error) {
            notification.error({ message: error });
        }
        setImage({ image, imageId });
        setUploading(false);
    };
    useEffect(() => {
        if (RouteParams['id']) {
            refreshItem();
        } else {
            setFetching(false);
        }
        refreshMetaData();
        setLang(localStorage.getItem('language'));
    }, []);

    if (fetching) {
        return <Skeleton active={true} />;
    }
    return (
        // <div className={props.hideHeader ? '' : 'list-page-wrapper'}>
        <div className={props.hideHeader ? '' : ''}>
            <div className='d-md-flex'>
                <FrontendSidebar menuSelect={2} />
                
                <div className={Parameters.Mode === 'CLIENT' ? 'profile-tab-content-div mb-3': 'mb-3'} style={{width: '100%'}}>
                    {
                    !props.hideHeader && <>
                        
                        <div className="container-fluid">
                            <div className='row'>
                                <div className='col-sm-6 mt-3'>
                               
                                     <h3><span className='back-bg mr-4 cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span> {RouteParams['mode'] === 'create' ? t('course.create') : ''}</h3>  
                                     {/* <h3><span className={lang == 'ar' ? 'ml-4' : 'back-bg mr-4 cursor-pointer'} onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span> {RouteParams['mode'] === 'create' ? t('course.create') : ''}</h3>   */}
                                </div>
                                <div className='col-sm-6 mt-3 mb-3 text-sm-right'>
                                    
                                </div>
                            </div>
                        </div>
                    </>
                }

    <div className="container-fluid">
    <div className='row'>
        <div className='col-md-12'>
        {RouteParams['mode'] !== 'details' ?<>
         <div>{history.goBack()}</div>
            {/* <div className='bg-white p-3 br-5px'>
                <div className="row">
                <div className="col-md-12 pt-3 pb-3">
                <Form
                    size='large'
                    form={form}
                    initialValues={item}
                    fields={[]}
                    className="msform"
                    onFinish={(value) => {
                    if(Parameters.Mode === 'CLIENT'){
                        const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
                        value.instructor_id = user.id;
                    }
                        if (!image.imageId) {
                            notification.error({ message: t('course.image.required') });
                            return;
                        }
                        const reqObj: any = fillEn(value);
                        reqObj['thumbnail_id'] = image.imageId;
                        setSaving(true);
                        if (item && item.id) {
                            API_SERVICE.updateCourse(item.id, reqObj).then((d) => {
                                history.goBack();
                            }).catch((e) => {
                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                setSaving(false);
                            });
                        } else {
                            API_SERVICE.createCourse(reqObj).then((d) => {
                                history.goBack();
                            }).catch((e) => {
                                notification.error({ message: API_SERVICE.handleErrors(e) });
                                setSaving(false);
                            });
                        }
                    }}
                    layout='vertical'
                    requiredMark={true}
                >
                        <div className="steps">
                            <ul id="progressbar" className="list-style-none w-100 d-flex">
                            <li className="w-100 steps-li">
                                <div className="progress">
                                    <div className="progress-bar w-100"></div>
                                </div>
                                <div className="d-flex align-items-center mt-2">
                                    <div className="mr-3">
                                        <span className="icon-bg"><img src={addCat}/></span>
                                        <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                    </div>
                                    <div>
                                        <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">Step 1</p>
                                        <p className="mb-0 text-uppercase small font-InterMedium">Select / create a category</p>
                                    </div>
                                </div>
                            </li>
                            <li className="w-100 steps-li">
                                <div className="progress">
                                    <div className="progress-bar"></div>
                                </div>
                                <div className="d-flex align-items-center mt-2">
                                    <div className="mr-3">
                                        <span className="icon-bg star"><img src={stars} style={{width:'29px'}}/></span>
                                        <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                    </div>
                                    <div>
                                        <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">Step 2</p>
                                        <p className="mb-0 text-uppercase small font-InterMedium">Select / select level</p>
                                    </div>
                                </div>
                            </li>
                            <li className="w-100 steps-li">
                                <div className="progress">
                                    <div className="progress-bar"></div>
                                </div>
                                <div className="d-flex align-items-center mt-2">
                                    <div className="mr-3">
                                        <span className="icon-bg video"><img src={video}/></span>
                                        <span className='step-circle'><img src={stepCircle} style={{width:'45px'}}/></span>
                                    </div>
                                    <div>
                                        <p className="small mb-0 text-uppercase font-InterMedium text-4f46e5">Step 3</p>
                                        <p className="mb-0 text-uppercase small font-InterMedium">create course</p>
                                    </div>
                                </div>
                            </li>
                            </ul>
                        </div>
                        <div className="form-fields pl-4 pr-6rem">
                            <fieldset>
                            <div className="row">
                                <div className="col-md-5 mt-5">
                                    <h5>Select Category</h5>
                                    <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-5">
                                <Form.Item
                                    label={t('course.category.label')}
                                    name={'category_id'}
                                    rules={[
                                        { required: true, message: t('course.category.required') },
                                    ]}>
                                    <Select className='select-cat br-1'>
                                        {
                                            categories.map((level: any) => {
                                                return <Option value={level.id}>{level.name}</Option>;
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                                <p className='mb-0'>Or <br/>
                                    <a onClick={() => history.push('/categories/create')} role="button" className='text-blue'><u>add new category</u></a>
                                </p>
                                </div>
                            </div>
                            <hr>
                            </hr>
                            <input type="button" name="next" id="next" className="next btn btn-blue float-right" value="Save and Continue" />
                            </fieldset>
                            <fieldset>
                            <div className="row">
                                <div className="col-md-5 mt-5">
                                    <h5>Category</h5>
                                    <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-5">
                                    <Form.Item
                                        label={t('course.category.label')}
                                        name={'category_id'}
                                        rules={[
                                            { required: true, message: t('course.category.required') },
                                        ]}>
                                        <Select className='br-1' disabled>
                                            {
                                                categories.map((level: any) => {
                                                    return <Option value={level.id}>{level.name}</Option>;
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                            <hr>
                            </hr>
                            <div className="row">
                                <div className="col-md-5 mt-4">
                                    <h5>Select Course Level</h5>
                                    <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-4">
                                <Form.Item
                                    label={t('course.level.label')}
                                    name={'level_id'}
                                    rules={[
                                        { required: true, message: t('course.level.required') },
                                    ]}>
                                    <Select className='br-1'>
                                        {
                                            levels.map((level: any) => {
                                                return <Option value={level.id}>{level.name}</Option>;
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                                </div>
                            </div>
                            <hr>
                            </hr>
                            <input type="button" name="next" className="next btn btn-blue float-right" value="Save and Continue" />
                            <input type="button" name="" className="previous btn btn-default float-right mr-3" value="Back" />
                            </fieldset>
                            <fieldset>
                            <div className="row">
                                <div className="col-md-5 mt-5">
                                    <h5>Upload Course Thumbnail</h5>
                                    <p className="text-secondary">This Information will be display the logo of the organisation</p>
                                </div>
                                <div className="col-md-7 mt-5">
                                {
                                    uploading ? <Spin/> : (
                                        image.image ? <div>
                                            
                                            <div className="d-flex align-items-center">
                                                <div className="uploadeImgBg mr-2">
                                                    <Image src={image.image} id="orgLogo" className="uploaded-img-cat" height={'48px'} width={'48px'}/>
                                                </div>
                                                <div>
                                                    {
                                                        RouteParams['mode'] !== 'view' && <Button className='btn btn-default' onClick={() => setImage({
                                                            image: null,
                                                            imageId: null,
                                                        })}>{t('genDict.remove')}</Button>
                                                        
                                                    }
                                                </div>
                                            </div>
                                            
                                        </div> : <Upload beforeUpload={(file) => {
                                                    if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                                        notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                                    }
                                                        uploadImage(file);
                                                        return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                                    }}>
                                                    <div className="d-flex align-items-center">
                                                        <div className="mr-2">
                                                            <img src={imgIcon} className="logo-org"/>
                                                        </div>
                                                        <div>
                                                            <Button className="btn btn-default">{t('genDict.uploadImage')}</Button>
                                                        </div>
                                                    </div>
                                                </Upload>
                                    )
                                }
                                </div>
                            </div>
                            <hr>
                            </hr> 
                            <div className="row">
                                <div className="col-md-5 mt-4">
                                    <h5>Course Information</h5>
                                    <p className="text-secondary">This information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-4">
                                    
                                    <Form.Item
                                        label={t('course.titleDe.label')}
                                        name={['title', 'de']}
                                        rules={[
                                            { required: true, message: t('course.titleDe.required') },
                                        ]}
                                    >
                                        <Input className='br-1' disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('course.title.label')}
                                        name={['title', 'en']}
                                        rules={[
                                            { required: true, message: t('course.title.required') },
                                        ]}>
                                        <Input className='br-1' disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        initialValue={item ? item.short_description.de : ''}
                                        label={t('course.shortDescriptionDe.label')}
                                        name={['short_description', 'de']}
                                        rules={[
                                            { required: true, message: t('course.shortDescriptionDe.required') },
                                        ]}
                                    >
                                        {RouteParams['mode'] === 'view' ?
                                            <Input className='br-1' disabled />
                                            : <TextArea rows={4} className='br-1' />
                                        }
                                    </Form.Item>
                                    <Form.Item
                                        initialValue={item ? item.short_description.en : ''}
                                        label={t('course.shortDescription.label')}
                                        name={['short_description', 'en']}
                                        rules={[]}>
                                        {RouteParams['mode'] === 'view' ?
                                            <Input className='br-1' disabled />
                                            : <TextArea rows={4} className='br-1' />
                                        }
                                    </Form.Item>
                                    <Form.Item
                                        initialValue={item ? item.benefits.de : ''}
                                        label={t('course.benefitsDe.label')}
                                        name={['benefits', 'de']}
                                        rules={[
                                            { required: true, message: t('course.benefitsDe.required') },
                                        ]}
                                    >
                                        {RouteParams['mode'] === 'view' ?
                                            <Input className='br-1' disabled />
                                            : <TextArea rows={4} className='br-1' />
                                        }
                                    </Form.Item>
                                    <Form.Item
                                        initialValue={item ? item.benefits.en : ''}
                                        label={t('course.benefits.label')}
                                        name={['benefits', 'en']}
                                        rules={[]}>
                                        {RouteParams['mode'] === 'view' ?
                                            <Input className='br-1' disabled />
                                            : <TextArea rows={4} className='br-1' />
                                        }
                                    </Form.Item>
                                    <Form.Item
                                        initialValue={item ? item.description.de : ''}
                                        label={t('course.descriptionDe.label')}
                                        name={['description', 'de']}
                                        rules={[
                                            { required: true, message: t('course.descriptionDe.required') },
                                            { min: 20, message: t('course.descriptionDe.minLength20') },
                                        ]}
                                    >
                                        {RouteParams['mode'] === 'view' ?
                                            <Input className='br-1' disabled />
                                            : <TextArea rows={4} className='br-1' />
                                        }
                                    </Form.Item>
                                    <Form.Item
                                        initialValue={item ? item.description.en : ''}
                                        label={t('course.description.label')}
                                        name={['description', 'en']}
                                        rules={[
                                            { required: true, message: t('course.descriptionDe.required') },
                                            { min: 20, message: t('course.description.minLength20') },

                                        ]}>
                                        {RouteParams['mode'] === 'view' ?
                                            <Input className='br-1' disabled />
                                            : <TextArea rows={4} className='br-1' />
                                        }
                                    </Form.Item>
                                </div>
                            </div>
                            <hr>
                            </hr>
                            <div className="row">
                                <div className="col-md-5 mt-4">
                                    <h5>Course Instructor</h5>
                                    <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-4">
                                {Parameters.Mode !== 'CLIENT' && <Form.Item
                                    label={t('course.instructor.label')}
                                    name={'instructor_id'}
                                    rules={[
                                        {required: true, message: t('course.instructor.required')},
                                    ]}>
                                    <Select className='br-1'>
                                        {
                                        instructors.map((instructor: any) => {
                                        return <Option value={instructor.id}>{instructor.name}</Option>;
                                        })
                                        }
                                    </Select>
                                </Form.Item>}
                                </div>
                            </div>
                            <hr>
                            </hr>
                            <div className="row">
                                <div className="col-md-5 mt-4">
                                    <h5>Classification</h5>
                                    <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-4">
                                <Form.Item
                                    label={t('course.isFeatured.label')}
                                    name='is_featured'
                                    valuePropName={'defaultChecked={true}'}
                                    rules={[]}
                                >
                                    <Switch disabled={!RouteParams['mode']} />
                                </Form.Item>
                                <Form.Item
                                    label={t('course.isPopular.label')}
                                    name='is_popular'
                                    valuePropName={'defaultchecked={true} value={"abc"}'}
                                    rules={[]}
                                >
                                    <Switch disabled={!RouteParams['mode']} />
                                </Form.Item>
                                </div>
                            </div>
                            <hr>
                            </hr>
                            <div className="row">
                                <div className="col-md-5 mt-4">
                                    <h5>Course Plan</h5>
                                    <p className="text-secondary">This Information will be display the identify of the administrator</p>
                                </div>
                                <div className="col-md-7 mt-4">
                                <Form.Item
                                    label={t('course.plan.label')}
                                    name={'plan'}
                                    rules={[
                                        { required: true, message: t('course.plan.required') },
                                    ]}>
                                    <Select className='br-1' onChange={(e)=>setPlan(e)}>
                                        {
                                            ['free', 'paid'].map((p) => {
                                                return <Option value={p}>{t('genDict.' + p)}</Option>;
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                                {
                                    form.getFieldsValue()['plan'] === 'paid' && <>
                                        <Form.Item
                                            label={t('course.price.label')}
                                            name={'price'}
                                            rules={[
                                                {
                                                    required: true, message: t('course.price.required'),
                                                },
                                            ]}>
                                            <InputNumber className='br-1' min={0.01} disabled={!RouteParams['mode']} />
                                        </Form.Item>
                                        <Form.Item
                                            label={t('course.salePrice.label')}
                                            name={'sale_price'}
                                            rules={[
                                                ({ getFieldValue }) => ({
                                                    validator(_, value) {
                                                        if (!value) {
                                                            return Promise.reject(
                                                                t('course.salePrice.required'),
                                                            );
                                                        }
                                                        if (value <= getFieldValue('price')) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(
                                                            t('course.salePrice.lessThanPrice'),
                                                        );
                                                    },
                                                }),
                                            ]}>
                                            <InputNumber className='br-1' min={0.01} disabled={!RouteParams['mode']} />
                                        </Form.Item>
                                    </>
                                }
                                </div>
                            </div>
                            <hr>
                            </hr>
                            {
                                RouteParams['mode'] !== 'view' && <><Form.Item>
                                            <Button
                                                htmlType="submit"
                                                loading={saving || uploading}
                                                size={'large'}
                                                className="submit btn-blue float-right"
                                            >
                                                {t('genDict.save')}
                                            </Button>
                                            </Form.Item><input type="button" name="" className="previous btn btn-default float-right mr-3" value="Back" /></>
                            }
                            </fieldset>
                        </div>
                    </Form>
                </div>
                </div>
            </div>*/}
            </>
            :''
        } 
        {RouteParams['mode'] === 'details' ?
        <AuthConsumer>
        {({ user }) => (
            (user?.id == item.instructor_id) || user?.role?.id == 2 && (user?.role?.slug !== 'STUDENT') ?
                <div className='bg-white p-3 br-5px'>
                    <div className="row">
                    <div className="col-sm-6 pb-3">
                        <div className="d-flex align-items-center">
                            <div className="mr-3">
                                <img src={image.image} className="uploaded-img-cat" height="50" width="50"/>
                            </div>
                            <div className="">
                                <h5 className="mb-0 font-18px">
                                    <span>{
                                            Parameters.DefaultLang === 'de' ? item.title.de : ''
                                        }
                                        {
                                            Parameters.DefaultLang === 'en' ? item.title.en : ''
                                        }
                                    </span>
                                </h5>
                            </div>
                        </div>
                        
                    </div>
                    <div className="col-sm-6 pb-3 text-sm-right my-auto">
                        <span className="text-secondary mr-4">{t('genDict.CreatedOn')}{item ? moment(item.created_at).format('DD MMMM, YYYY'): ''}</span>
                        <span className="dropdown">
                            <a role="button" className="dropdown-toggler" data-toggle="dropdown">
                                <img src={vDOts} style={{width: '25px'}} />
                            </a>
                            <div className="dropdown-menu">
                            <a className="dropdown-item" role="button"
                            onClick={() => {
                                history.push(`${Parameters.Mode === 'CLIENT' ? '/my/management' : ''}/courses/${item.id}/edit`);
                            }}
                            >{t('genDict.Edit')}</a>
                            <a role="button" className="dropdown-item"
                            onClick={() => confirm({
                                icon: <ExclamationCircleOutlined/>,
                                title: t('genDict.confirmDelete'),
                                okText: t('genDict.ok'),
                                cancelText: t('genDict.cancel'),
                                content: `${t('genDict.confirmDelete')} "${
                                    item.id ?
                                        Parameters.DefaultLang === 'de' ? item.title.de : Parameters.DefaultLang === 'en' ? item.title.en : ''
                                    : ''
                                }"`,
                                okButtonProps: { loading: deletingItem, danger: true },
                                onOk: async () => {
                                    setDeletingItem(true);
                                    API_SERVICE.removeCourse(item.id).then((d) => {
                                        notification.success({
                                            message: t('genDict.success'),
                                        });
                                        history.push('/courses/');
                                    }).catch((e: any) => {
                                        notification.error({
                                            message: t(API_SERVICE.handleErrors(e)),
                                        });
                                    }).finally(() => {
                                        setDeletingItem(false);
                                    });
                                },
                            })
                        }
                            > {t('genDict.delete')}</a>
                            </div>
                        </span>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12 pb-3">
                        <div className="table-responsive mt-2">
                        {console.log(item)}
                            <table className="table course-details-table box-shadow">
                                    
                                    <tbody>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.category')}</td>
                                        <td>{item.category.name}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.level')}</td>
                                        <td>{item.level.name}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.Instructor')}</td>
                                        <td>{item.author.name}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.salePrice')}</td>
                                        <td>{item.plan === 'free' ? 'Free' : item.sale_price}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.price')}</td>
                                        <td>{item.plan === 'free' ? 'Free' : item.price}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.Classification')}</td>
                                        <td>{item.is_featured === 1 ? 'Featured' : 'Not Featured'}, {item.is_popular === 1 ? 'Popular' : 'Not Popular'}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.Module')}</td>
                                        <td>{item?.curriculum_count}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.content')}</td>
                                        <td>{item?.content_count}</td>
                                    </tr>
                                    <tr>
                                        <td className="w-280px text-secondary">{t('genDict.Quiz')}</td>
                                        <td>{item?.quiz_count}</td>
                                    </tr>
                                    </tbody>
                                </table>
                        </div>
                    </div>
                    </div>
                </div>
                    : <><div>
                    {setFetching(true)}
                    <h5 className="text-center mt-5 mb-5">{t('genDict.PermissionDenied')}</h5>
                    {setFetching(false)}
                </div>
            </>
            )}
            </AuthConsumer>
        :''
        }
        </div>
    </div>
    </div>

                {/* <Row>
                <Col lg={12} md={12} sm={24} xs={24} className={'text-center'}>
                        {
                            uploading ? <Spin /> : (
                                image.image ? <div>
                                    <Space direction={'vertical'}>
                                        <Image src={image.image} width={'300px'} />
                                        {
                                            RouteParams['mode'] && <Button danger onClick={() => setImage({
                                                image: null,
                                                imageId: null,
                                            })}>{t('genDict.remove')}</Button>
                                        }
                                    </Space>
                                </div> : <Upload beforeUpload={(file) => {
                                    if (!(file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                                        notification.error({ message: `PNG/JPG/JPEG ${t('genDict.required')}` });
                                    }
                                    uploadImage(file);
                                    return file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
                                }}>
                                    <Button icon={<UploadOutlined />}>{t('genDict.uploadImage')}</Button>
                                </Upload>
                            )
                        }
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                        <Form
                            size='large'
                            form={form}
                            initialValues={item}
                            fields={[]}
                            onFinish={(value) => {
                            if(Parameters.Mode === 'CLIENT'){
                                const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
                                value.instructor_id = user.id;
                            }
                                if (!image.imageId) {
                                    notification.error({ message: t('course.image.required') });
                                    return;
                                }
                                const reqObj: any = fillEn(value);
                                reqObj['thumbnail_id'] = image.imageId;
                                setSaving(true);
                                if (item && item.id) {
                                    API_SERVICE.updateCourse(item.id, reqObj).then((d) => {
                                        history.goBack();
                                    }).catch((e) => {
                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                        setSaving(false);
                                    });
                                } else {
                                    API_SERVICE.createCourse(reqObj).then((d) => {
                                        history.goBack();
                                    }).catch((e) => {
                                        notification.error({ message: API_SERVICE.handleErrors(e) });
                                        setSaving(false);
                                    });
                                }
                            }}
                            layout='vertical'
                            requiredMark={true}
                        >

                            <Form.Item
                                label={t('course.titleDe.label')}
                                name={['title', 'de']}
                                rules={[
                                    { required: true, message: t('course.titleDe.required') },
                                ]}
                            >
                                <Input disabled={!RouteParams['mode']} />
                            </Form.Item>
                            <Form.Item
                                label={t('course.title.label')}
                                name={['title', 'en']}
                                rules={[
                                    { required: true, message: t('course.title.required') },
                                ]}>
                                <Input disabled={!RouteParams['mode']} />
                            </Form.Item>
                            <Form.Item
                                initialValue={item ? item.short_description.de : ''}
                                label={t('course.shortDescriptionDe.label')}
                                name={['short_description', 'de']}
                                rules={[
                                    { required: true, message: t('course.shortDescriptionDe.required') },
                                ]}
                            >
                                {RouteParams['mode'] === 'view' ?
                                    <Input disabled />
                                    : <TextArea rows={4} />
                                }
                            </Form.Item>
                            <Form.Item
                                initialValue={item ? item.short_description.en : ''}
                                label={t('course.shortDescription.label')}
                                name={['short_description', 'en']}
                                rules={[
                                    //{ required: true, message: t('course.shortDescription.required') },
                                ]}>
                                {RouteParams['mode'] === 'view' ?
                                    <Input disabled />
                                    : <TextArea rows={4} />
                                }
                            </Form.Item>
                            <Form.Item
                                initialValue={item ? item.benefits.de : ''}
                                label={t('course.benefitsDe.label')}
                                name={['benefits', 'de']}
                                rules={[
                                    { required: true, message: t('course.benefitsDe.required') },
                                ]}
                            >
                                {RouteParams['mode'] === 'view' ?
                                    <Input disabled />
                                    : <TextArea rows={4} />
                                }
                            </Form.Item>
                            <Form.Item
                                initialValue={item ? item.benefits.en : ''}
                                label={t('course.benefits.label')}
                                name={['benefits', 'en']}
                                rules={[
                                    //{ required: true, message: t('course.benefits.required') },
                                ]}>
                                {RouteParams['mode'] === 'view' ?
                                    <Input disabled />
                                    : <TextArea rows={4} />
                                }
                            </Form.Item>
                            <Form.Item
                                initialValue={item ? item.description.de : ''}
                                label={t('course.descriptionDe.label')}
                                name={['description', 'de']}
                                rules={[
                                    { required: true, message: t('course.descriptionDe.required') },
                                    { min: 20, message: t('course.descriptionDe.minLength20') },
                                ]}
                            >
                                {RouteParams['mode'] === 'view' ?
                                    <Input disabled />
                                    : <TextArea rows={4} />
                                }
                            </Form.Item>
                            <Form.Item
                                initialValue={item ? item.description.en : ''}
                                label={t('course.description.label')}
                                name={['description', 'en']}
                                rules={[
                                    { required: true, message: t('course.descriptionDe.required') },
                                    { min: 20, message: t('course.description.minLength20') },

                                ]}>
                                {RouteParams['mode'] === 'view' ?
                                    <Input disabled />
                                    : <TextArea rows={4} />
                                }
                            </Form.Item>
                            <Form.Item
                                label={t('course.plan.label')}
                                name={'plan'}
                                rules={[
                                    { required: true, message: t('course.plan.required') },
                                ]}>
                                <Select onChange={(e)=>setPlan(e)}>
                                    {
                                        ['free', 'paid'].map((p) => {
                                            return <Option value={p}>{t('genDict.' + p)}</Option>;
                                        })
                                    }
                                </Select>
                            </Form.Item>
                        {Parameters.Mode !== 'CLIENT' && <Form.Item
                            label={t('course.instructor.label')}
                            name={'instructor_id'}
                            rules={[
                            {required: true, message: t('course.instructor.required')},
                            ]}>
                            <Select>
                            {
                                instructors.map((instructor: any) => {
                                return <Option value={instructor.id}>{instructor.name}</Option>;
                                })
                            }
                            </Select>
                        </Form.Item>}
                            <Form.Item
                                label={t('course.level.label')}
                                name={'level_id'}
                                rules={[
                                    { required: true, message: t('course.level.required') },
                                ]}>
                                <Select>
                                    {
                                        levels.map((level: any) => {
                                            return <Option value={level.id}>{level.name}</Option>;
                                        })
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={t('course.category.label')}
                                name={'category_id'}
                                rules={[
                                    { required: true, message: t('course.category.required') },
                                ]}>
                                <Select>
                                    {
                                        categories.map((level: any) => {
                                            return <Option value={level.id}>{level.name}</Option>;
                                        })
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={t('course.isFeatured.label')}
                                name='is_featured'
                                valuePropName={'defaultChecked={true} value={"abc"}'}
                                rules={[]}
                            >
                                <Switch disabled={!RouteParams['mode']} />
                            </Form.Item>
                            <Form.Item
                                label={t('course.isPopular.label')}
                                name='is_popular'
                                valuePropName={'defaultChecked={true} value={"abc"}'}
                                rules={[]}
                            >
                                <Switch disabled={!RouteParams['mode']} />
                            </Form.Item>
                            {
                                form.getFieldsValue()['plan'] === 'paid' && <>
                                    <Form.Item
                                        label={t('course.price.label')}
                                        name={'price'}
                                        rules={[
                                            {
                                                required: true, message: t('course.price.required'),
                                            },
                                        ]}>
                                        <InputNumber min={0.01} disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('course.salePrice.label')}
                                        name={'sale_price'}
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value) {
                                                        return Promise.reject(
                                                            t('course.salePrice.required'),
                                                        );
                                                    }
                                                    if (value <= getFieldValue('price')) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        t('course.salePrice.lessThanPrice'),
                                                    );
                                                },
                                            }),
                                        ]}>
                                        <InputNumber min={0.01} disabled={!RouteParams['mode']} />
                                    </Form.Item>
                                </>
                            }
                            <br />
                            {
                                RouteParams['mode'] && <Form.Item>
                                    <Button
                                        type='primary'
                                        htmlType='submit'
                                        loading={saving || uploading}
                                        shape='round'
                                        size={'large'}
                                        className='submit'
                                    >
                                        {t('genDict.save')}
                                    </Button>
                                </Form.Item>
                            }
                        </Form>
                    </Col>
                </Row>  */}
                </div>
            </div>
        </div>
    );
}
